

















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ProfitLossTable extends Vue {
  @Prop() readonly profitloss!: any;

  rows: any = [
    { text: Vue.prototype.$t('Nettoomsättning'), values: ['A', 'C'], styles: [''] },
    { text: Vue.prototype.$t('Övriga rörelseintäkter'), values: ['B', 'C'], styles: [''] },
    { text: Vue.prototype.$t('Summa intäkter'), values: ['C', 'C'], styles: ['major_sum'] },
    {
      text: Vue.prototype.$t('Kostnader för varor och material'),
      values: ['D', 'C'],
      styles: [''],
    },
    { text: Vue.prototype.$t('Bruttoresultat'), values: ['E', 'C'], styles: ['minor_sum'] },
    { text: Vue.prototype.$t('Övriga externa kostnader'), values: ['F', 'C'], styles: [''] },
    { text: Vue.prototype.$t('Personalkostnader'), values: ['G', 'C'], styles: [''] },
    { text: Vue.prototype.$t('Övriga rörelsekostnader'), values: ['H', 'C'], styles: [''] },
    { text: Vue.prototype.$t('Driftsresultat'), values: ['I', 'C'], styles: ['minor_sum'] },
    { text: Vue.prototype.$t('Av- och nedskrivningar'), values: ['J', 'C'], styles: [''] },
    { text: Vue.prototype.$t('Rörelseresultat'), values: ['K', 'C'], styles: ['major_sum'] },
    { text: Vue.prototype.$t('Finansiella intäkter'), values: ['L', 'C'], styles: [''] },
    { text: Vue.prototype.$t('Finansiella kostnader'), values: ['M', 'C'], styles: [''] },
    {
      text: Vue.prototype.$t('Resultat efter finansiella poster'),
      values: ['N', 'C'],
      styles: ['minor_sum'],
    },
    { text: Vue.prototype.$t('Bokslutsdispositioner'), values: ['O', 'C'], styles: [''] },
    { text: Vue.prototype.$t('Resultat före skatt'), values: ['P', 'C'], styles: ['minor_sum'] },
    { text: Vue.prototype.$t('Skatt på årets resultat'), values: ['Q', 'C'], styles: [''] },
    { text: Vue.prototype.$t('Årets resultat'), values: ['R', 'C'], styles: ['major_sum'] },
  ];
  cols: any = [];
  hoveredCol: number = -1;
  hoveredRow: number = -1;

  getColsClass() {
    return 'cols' + this.cols.length;
  }

  getHovered(col: number, row: number) {
    if (col === this.hoveredCol && row === this.hoveredRow) {
      return 'hovered-exact';
    } else if (col === this.hoveredCol || row === this.hoveredRow) {
      return 'hovered';
    }
    return '';
  }

  mouseOver(col: number, row: number) {
    this.hoveredCol = col;
    this.hoveredRow = row;
  }

  mouseOut() {
    this.hoveredCol = -1;
    this.hoveredRow = -1;
  }

  val(i: number, row: any) {
    const name = row.values[0];
    if (name === undefined) {
      return '';
    }
    return this.profitloss.sheets[i][name];
  }

  part(i: number, row: any) {
    const name1 = row.values[0];
    const name2 = row.values[1];
    if (name1 === undefined || name2 === undefined) {
      return '';
    }
    const n1 = Number(this.profitloss.sheets[i][name1]);
    const n2 = Number(this.profitloss.sheets[i][name2]);
    if (n2 === 0) {
      return 0;
    }
    return n1 / n2;
  }

  title(i: number) {
    return (
      this.profitloss.sheets[i].DATE_TO.substr(0, 7) +
      ' (' +
      this.profitloss.sheets[i].MONTHS + ' ' +
      Vue.prototype.$t('mån') + ')'
    );
  }

  @Watch('profitloss', { immediate: true, deep: true })
  onProfitlossChanged(newVal: any, oldVal: any) {
    this.cols.splice(0, this.cols.length);
    if (this.profitloss !== undefined) {
      for (let i = 0; i < this.profitloss.count; i++) {
        this.cols.push(i);
      }
    }
  }
}
